// here we add all base urls and keys

import { update_root_value } from "src/utils/domUtils";

// Base URLS
// export const baseUri = "http://192.168.1.234:4630";

export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const socketUrl = process.env.REACT_APP_SOCKET_URL;
export const project_name = process.env.REACT_APP_PROJECT_NAME;
export const project_url = process.env.REACT_APP_PROJECT_URL;
export const client_url = process.env.REACT_APP_CLIENT_URL;
export const project_type = process.env.REACT_APP_PROJECT_TYPE;
export const clientPortalUrl = process.env.REACT_APP_CLIENT_PORTAL_URL;
export const coachPortalUrl = process.env.REACT_APP_COACH_PORTAL_URL;

// Harmony Ring (programme compliance ring / graph, "Harmony Member", non-compliant highlight in the
// members list) is hidden for now: client asked to simplify. To bring it back set
// REACT_APP_HARMONY_RING_ENABLED=true in the .env file and rebuild. The backend is unchanged.
export const harmonyRingEnabled =
  process.env.REACT_APP_HARMONY_RING_ENABLED === "true";

export const material_theme_palate = {
  lighter: "#04abbb",
  light: "#04abbb",
  main: "#04abbb",
  dark: "#04abbb",
  darker: "#04abbb",
  contrastText: "#fff",
};

// BMS Gym Theme Configuration
material_theme_palate.main = "#04abbb";

/* Main theme color */
update_root_value("--portal-theme-primary", "#04abbb");
update_root_value("--portal-theme-secondary", "#04abbb17");
update_root_value("--text-primary-color", "black");
update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
update_root_value("--text-color", "black");

/* Main background color*/
update_root_value("--background-primary-color", "#fff");
update_root_value("--background-secondary-color", "#fff");

/* Sidebar Properties */
update_root_value("--sidebars-text-color", "black");
update_root_value("--sidebars-active-color", "#C19D60");
update_root_value("--sidebars-hover-color:", "#C19D60");
update_root_value("--sidebars-background-color", "#ffffff");

/* Popup / Popover properties  */
update_root_value("--popup-background-color", "white");
update_root_value("--popup-text-color", "#04abbb");

/* Element properties */
update_root_value("--input-text-color", "black");
update_root_value("--input-placeholder-color", "#fff");
update_root_value("--input-background-primary", "#fff");
update_root_value("--input-background-secondary", "#1d1c1d");
update_root_value(" --icons-color-allover", "#C19D60");

/* Button Properties */
update_root_value("--button-background-color", "#04abbb");
update_root_value("--button-text-color", "#fff");
update_root_value("--button-outlined-color", "#04abbb");
update_root_value("--button-hover-color", "#04abbb");

/* Audio Properties */
update_root_value("--audio-color", "rgb(56, 54, 54)");

/* calendar Properties */
update_root_value("--calendar-selected-box", "#8b8b8b");

// Keys
// export const secret_key = process.env.REACT_APP_API_SECRET_KEY;
